import _ from 'lodash'
export {findAndReplace} from './find_and_replace'
export {alwaysArray, alwaysDefArray, alwaysDefinedArray, alwaysTruthyArray} from './always_array'

export function getMax(collection, key = 'updated_at') {
	const items = collection.filter(a => a[key])
	if (items.length === 0) return null
	return items.reduce((a, b) => (a[key] > b[key] ? a : b))
}

export function getMin(collection, key = 'updated_at') {
	const items = collection.filter(a => a[key])
	if (items.length === 0) return null
	return items.reduce((a, b) => (a[key] > b[key] ? b : a))
}

export function toggle(arr, nieuw) {
	if (_.isArray(nieuw)) return toggleArray(arr, nieuw)
	arr = _.cloneDeep(arr)
	if (arr.includes(nieuw)) {
		arr = arr.filter(item => item !== nieuw)
	} else {
		arr.push(nieuw)
	}
	return arr
}

export function toggleArray(arr, newArr) {
	let finalArr = arr
	newArr.forEach(item => {
		finalArr = toggle(finalArr, item)
	})
	return finalArr
}

export function getIdsFromItems(ids, items) {
	return ids.filter(id => items.some(item => item.id === id))
}

export function mergeJoinItems(joinTableItems, mainItems, key) {
	return joinTableItems.map(i => ({...i, ...mainItems.find(i2 => i2.id === i[key])}))
}

export function reduce(items) {
	return items.filter(Number).reduce((item, tally) => item + tally, 0)
}

export function sum(arr = [], field) {
	const mapper = i => {
		if (_.isFunction(field)) return field(i)
		return i[field] || 0
	}

	return reduce(arr.map(mapper))
}
